import instance from './axiosInstance';

export const getNetworkRequestDefaultData = (reqBody) => {
  return instance.post('/appData/networkRequestDefault', reqBody);
};
